import { registerBlock } from '../../core/registry.js';
import { HeadingCanvas, HeadingInspector } from './Canvas.jsx';

const definition = {
  type: 'heading',
  schema: {
    defaults: () => ({ level: 2, html: '', className: '' }),
  },
  capabilities: {
    isContainer: false,
  },
  ui: {
    Canvas: HeadingCanvas,
    Inspector: HeadingInspector,
    icon: '🔤',
    label: 'Heading',
    keywords: ['title', 'h1', 'h2', 'h3', 'header'],
  },
  serialize: (attrs) => {
    const tag = `h${attrs.level || 2}`;
    const cls = attrs.className ? ` class="${attrs.className}"` : '';
    return `<${tag}${cls}>${attrs.html || ''}</${tag}>`;
  },
};

registerBlock(definition);
export default definition;
